import React from 'react';
import queryString from 'query-string';

import { PersonContext } from '../contexts/PersonContext';
import history from '../history';

class Logout extends React.Component {
  async componentDidMount() {
    const { logOut } = this.context;
    await logOut();
    const queryParams = queryString.parse(location.search);

    if (queryParams.page /* && window.location.pathname !== '/sso' */) {
      localStorage.setItem('page', queryParams.page);
      delete queryParams.page;
      history.replace({
        search: queryString.stringify(queryParams),
      });
    }
  }

  render() {
    return null;
  }
}

Logout.contextType = PersonContext;

export default Logout;
